import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_OON_CONSENT_QUERY from './getOONConsent.gql';

const parseResult = result => {
  const initialState = {};

  const getPopup = get(result, 'core.getPopup');

  return {
    ...initialState,
    ...getPopup,
  };
};

export const useGetOONConsentQuery = options => {
  const [queryResult, queryAction] = useQuery(GET_OON_CONSENT_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
